import { api } from "@/api/client";

export type Assessment = {
  id: string;
  tenant_id: string;
  title: string;
  assessment_type: string;
  status: string;
  current_step: number;
  asset_id: string | null;
  cluster_id: string | null;
  lead_assessor_id: string | null;
  review_status: string;
  review_notes: string | null;
  reviewed_by: string | null;
  started_at: string | null;
  completed_at: string | null;
  scope_asset_ids: string[];
  compliance_tags: string[];
  created_at: string;
  updated_at: string;
};

export type AssessmentCreate = {
  title: string;
  assessment_type?: string;
  status?: string;
  current_step?: number;
  asset_id?: string | null;
  cluster_id?: string | null;
  lead_assessor_id?: string | null;
  review_status?: string;
  review_notes?: string | null;
  scope_asset_ids?: string[];
  compliance_tags?: string[];
};

export type AssessmentUpdate = Partial<AssessmentCreate>;

export type AssessmentListParams = {
  limit?: number;
  offset?: number;
  status?: string;
  assessment_type?: string;
  asset_id?: string;
  search?: string;
};

function toSearchParams(
  params: AssessmentListParams | undefined,
): URLSearchParams | undefined {
  if (!params) return undefined;
  const sp = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    const str = String(value);
    if (str === "" || str === "undefined") continue;
    sp.append(key, str);
  }
  return sp;
}

export async function listAssessments(
  params?: AssessmentListParams,
): Promise<Assessment[]> {
  return api.get("assessments", { searchParams: toSearchParams(params) }).json<Assessment[]>();
}

export async function getAssessment(id: string): Promise<Assessment> {
  return api.get(`assessments/${id}`).json<Assessment>();
}

export async function createAssessment(payload: AssessmentCreate): Promise<Assessment> {
  return api.post("assessments", { json: payload }).json<Assessment>();
}

export async function updateAssessment(
  id: string,
  payload: AssessmentUpdate,
): Promise<Assessment> {
  return api.patch(`assessments/${id}`, { json: payload }).json<Assessment>();
}

export async function deleteAssessment(id: string): Promise<void> {
  await api.delete(`assessments/${id}`);
}
